import { render, staticRenderFns } from "./MatrixAnswer.vue?vue&type=template&id=17321d62&scoped=true"
import script from "./MatrixAnswer.vue?vue&type=script&lang=js"
export * from "./MatrixAnswer.vue?vue&type=script&lang=js"
import style0 from "./MatrixAnswer.vue?vue&type=style&index=0&id=17321d62&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17321d62",
  null
  
)

export default component.exports